import React, { useContext, useEffect, useState } from 'react'

import { Card } from 'antd'
import IconClassification from '../../../assets/images/Star.svg'
import IconPontuation from '../../../assets/images/icone.svg'
import IconPlannedAction from '../../../assets/images/prioridade.svg'
import IconActionPlanned from '../../../assets/images/checklist.svg'
import IconCoverage from '../../../assets/images/roofIconBlack.svg'
import { CustomerActionsPlanContext } from './CustomerActionsPlan'
import './CardsActionPlan.css'
import moment from 'moment'

const CardsActionPlan = function () {
  const { customerLocations, filters, customer, formatArea, formatAcoesExecutadas } =
    useContext(CustomerActionsPlanContext)
  const [customerClassification, setCustomerClassification] = useState(0)
  const [customerPoints, setCustomerPoints] = useState(0)
  const [customerCoverage, setCustomerCoverage] = useState(0)
  const [customerPlannedActions, setCustomerPlannedActions] = useState(0)
  const [customerExecutedActions, setCustomerExecutedActions] = useState('')

  useEffect(() => {
    if (customer.id && customerLocations.length) {
      formatCards(customer.id, filters)
    }
  }, [customerLocations])

  async function formatCards() {
    const { eibClassificacao, eibPontos } = customer
    let plannedActions = 0
    let executedActions = 0
    let totalArea = 0

    setCustomerClassification(eibClassificacao)
    setCustomerPoints(eibPontos)

    customerLocations.forEach((location) => {
      totalArea += location.totalArea
      plannedActions += location.planned
      executedActions += location.executed
    })

    setCustomerPlannedActions(plannedActions)
    setCustomerExecutedActions(formatAcoesExecutadas(plannedActions, executedActions))
    setCustomerCoverage(formatArea(totalArea))
  }

  return (
    <div>
      <p>Última atualização em {customer.updatedAt && moment(customer.updatedAt).format('DD/MM/YYYY')}</p>
      <div className="main-cards">
        <Card className="ant-card-bordered card">
          <div className="container-card">
            <img src={IconClassification} alt="IconClassification" style={{ marginRight: 10, width: 25, height: 25 }} />
            <div className="label-card-info">
              <span>Classificação Impulso Bayer</span>
              <span className="content-card">{customerClassification}</span>
            </div>
          </div>
        </Card>

        <Card className="ant-card-bordered card">
          <div className="container-card">
            <img src={IconPontuation} alt="IconPontuation" style={{ marginRight: 10, width: 25, height: 25 }} />
            <div className="label-card-info">
              <span>Pontuação</span>
              <span className="content-card">{customerPoints}</span>
            </div>
          </div>
        </Card>

        <Card className="ant-card-bordered card">
          <div className="container-card">
            <img src={IconPlannedAction} alt="IconPlannedAction" style={{ marginRight: 10, width: 25, height: 25 }} />
            <div className="label-card-info">
              <span>Ações Planejadas</span>
              <span className="content-card">{customerPlannedActions}</span>
            </div>
          </div>
        </Card>

        <Card className="ant-card-bordered card">
          <div className="container-card">
            <img src={IconActionPlanned} alt="IconActionPlanned" style={{ marginRight: 10, width: 25, height: 25 }} />
            <div className="label-card-info">
              <span>Ações Executadas</span>
              <div className="executed-session">
                <span className="total-executed-action">{customerExecutedActions.split(/[()]/)[0]}</span>
                <span className="percents-executed-action">
                  {customerExecutedActions !== '' ? `(` + customerExecutedActions.split(/[()]/)[1] + `)` : ''}
                </span>
              </div>
            </div>
          </div>
        </Card>

        <Card className="ant-card-bordered card">
          <div className="container-card">
            <img src={IconCoverage} alt="IconCoverage" style={{ marginRight: 10, width: 25, height: 25 }} />
            <div className="label-card-info">
              <span>Cobertura</span>
              <span className="content-card">{customerCoverage}</span>
            </div>
          </div>
        </Card>
      </div>
    </div>
  )
}

export default CardsActionPlan
